import React, { useState, useEffect } from "react";
import authStorage from "../../utils/authStorage";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { BASE_URL } from "../../config";
import moment from "moment";
import tickCrcleArrow from "../../assets/images/tick-circle-icon.svg";

const PaymentAppConfirmationPage = ({ back}) => {
    const [currentMonth, setCurrentMonth] = useState(new Date().getMonth() + 1);
    const [currentYear, setCurrentYear] = useState(new Date().getFullYear());
    const [currentDay, setSelectedDay] = useState('');
    const [selectedFullDate, setSelectedFullDate] = useState('');
    const [selectedSlots, setSelectedSlots] = useState('');
    const [bookedSlots, setBookedSlots] = useState([]);
    const [availavleSlots, setAvailavleSlots] = useState([]);
    const [paymentDetail, setPaymentDetail] = useState();
    const [error, setError] = useState('');
    const [amoun, setAmoun] = useState();
    const [loading, setLoading] = useState(true);
    const navigate = useNavigate();
    const[receiptGloUrl,setReceiptGloUrl]=useState();
    const[invoiceDownloadUrl,setInvoiceDownloadUrl]=useState();

    const createTrainningSession = () => {
        setLoading(true);

        const sessionId = authStorage.getItem("training_session_id");

        if (sessionId) {
            axios.get(`${BASE_URL}/auth/stripe/session/${sessionId}`,
                { headers: { "x-access-token": authStorage.getItem("auth-token") } }
            )
                .then(res => {
                    console.log("PaymentIntent ID:", res.data.payment_intent);
                    // proceed to call createTrainningSession with res.data.payment_intent

                    axios.post(`${BASE_URL}/user/create/training/session`, 
                        { paymentIntent: res.data.payment_intent },
                        { headers: { "x-access-token": authStorage.getItem("auth-token") } }
                    ).then((res) => {
                        authStorage.setItem("payData", JSON.stringify(res.data));
                        setPaymentDetail(res.data?.data);
                        setReceiptGloUrl(res.data?.receiptUrl);
                        setInvoiceDownloadUrl(res.data?.invoiceDownloadUrl);
                        setLoading(false);

                        setTimeout(() => {
                            window.location.href = `cftapp://auth-callback-training?token=${authStorage.getItem("auth-token")}`;
                        }, 2000);
                    }).catch((err) => {
                        console.error(err);
                        setLoading(false);
                    });
                })
                .catch(err => console.error(err))
                .finally(() => {
                    authStorage.removeItem("session_id");
                });
        }
    };

    useEffect(() => {
        createTrainningSession();
    }, []);

    return (
        <div className="payment-completed">
            <div className="">
                <div className="icon-box">
                <img src={tickCrcleArrow} />
                </div>
                <h1>Payment Completed!</h1>
                <a
                    href="#"
                    className="continue-btn"
                    onClick={() => {
                        window.location.href =
                        "cftapp://auth-callback-training?token=" + authStorage.getItem("auth-token");
                    }}
                >
                Continue
                </a>
            </div>
        </div>
    );
}

export default PaymentAppConfirmationPage;